import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/CommunityBanner/CommunityBanner.js
const CommunityBanner = createSectionForm({
  icon: "team-line",
  title: "Community Banner",
  fields: [
    { name: "title", label: "Title", type: "textarea", rows: 2, help: "Basic HTML allowed." },
    { name: "description", label: "Description", type: "richtext" },
    { name: "image", label: "Image", type: "media" },
  ],
});

export default CommunityBanner;
